import { Routes } from '@angular/router';
import {
  CancelChangeEmailSuccessComponent,
  ChangeEmailErrorComponent,
  ChangeEmailSuccessComponent,
  ForgotPasswordComponent,
  LoginComponent,
  SelectAccountComponent,
  SetPasswordComponent,
  SetPasswordInvalidTokenComponent,
  SetPasswordSuccessComponent,
  SignupComponent,
  UnusualActivityComponent,
  VerifyLoginComponent,
} from './containers';
import { AppGuard } from '../app/guards';
import {
  AccountSelectorGuard,
  CancelChangeEmailTokenGuard,
  ChangeEmailTokenGuard,
  RedirectGuard,
  ReferralGuard,
  SetPasswordTokenGuard,
  UnusualActivityGuard,
  VerifyLoginGuard,
} from './guards';
import { LEGACY_ROUTES } from './legacy.routes';
import { VerifyEmailComponent } from './containers/verify-email/verify-email.component';
import { VerifyEmailResolve } from './resolves/verify-email.resolve';

export const ROUTES: Routes = [
  ...LEGACY_ROUTES,
  {
    path: '',
    canActivate: [AppGuard, ReferralGuard, RedirectGuard],
    children: [
      {
        path: '',
        component: LoginComponent,
      },
      {
        path: 'register',
        component: SignupComponent,
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
      },
      {
        path: 'set-password',
        children: [
          {
            path: '',
            component: SetPasswordComponent,
            canActivate: [SetPasswordTokenGuard],
          },
          {
            path: 'success',
            component: SetPasswordSuccessComponent,
          },
          {
            path: 'invalid',
            component: SetPasswordInvalidTokenComponent,
          },
        ],
      },
      {
        path: 'change-email',
        children: [
          {
            path: '',
            component: ChangeEmailSuccessComponent,
            canActivate: [ChangeEmailTokenGuard],
          },
          {
            path: 'cancel',
            component: CancelChangeEmailSuccessComponent,
            canActivate: [CancelChangeEmailTokenGuard],
          },
          {
            path: 'invalid',
            component: ChangeEmailErrorComponent,
          },
        ],
      },
      {
        path: 'accounts',
        component: SelectAccountComponent,
        canActivate: [AccountSelectorGuard],
      },
      {
        path: 'unusual-activity',
        component: UnusualActivityComponent,
        canActivate: [UnusualActivityGuard],
      },
      {
        path: 'verify-login',
        component: VerifyLoginComponent,
        canActivate: [VerifyLoginGuard],
      },
      {
        path: 'verify-email',
        component: VerifyEmailComponent,
        resolve: {
          didSucceed: VerifyEmailResolve,
        },
      },
    ],
  },
];
